import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store';

import { pickSelectionsFromFilter } from './pickSelectionFromFilter';

export const useFilterSelections = (instanceId: string) =>
  useStore(
    useShallow((state) =>
      pickSelectionsFromFilter(state.filterData?.[instanceId]?.visualisedFilter)
    )
  );

export const useFilterSelectionsForQuery = (instanceId: string) =>
  useStore(
    useShallow((state) => state.filterData?.[instanceId]?.selectionForQueryKey)
  );
